module.exports = __webpack_public_path__ + "images/柏纳s长图_06-1.jpg?v=a491e27f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_06-1.jpg
 ** module id = 164
 ** module chunks = 1 2
 **/